import { useQuery } from '@tanstack/react-query';
import { tradesService } from '@/services';
import { TradeListParams } from '@/types';
import { queryKeys } from '@/services/query-keys';

export const useTradesList = (params?: TradeListParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: queryKeys.trades.list(params),
    queryFn: () => tradesService.getTradesList(params),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled,
  });
};

